import { Input } from "../../../components/Input/input";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { StyledButton } from "../../../components/Button/button";
import { theme } from "../../../helpers/theme";
import { useMutation } from "@tanstack/react-query";
import { addressAdd } from "../../../services/address/add";
import { toast, ToastOptions } from "react-toastify";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { addressVoivodeshipsList } from "../../../helpers/voievodeshipsList";
import { GoBackButton } from "../../../components/GoBackButton";
import { AddressAddBody } from "../../../services/address/add/types";
import { useEffect } from "react";

interface AddressAddFormProps {
  // setAddressId: (addressId: string) => void;
  setAddressDataValid: (addressDataValid: boolean) => void;
  addressData: AddressAddBody | null;
  setAddressData: (addressData: AddressAddBody | null) => void;
}

export const AddressAddForm = ({ setAddressDataValid, addressData, setAddressData}:AddressAddFormProps) => {

  // const settings: ToastOptions<{}> = {
  //   position: "top-center",
  //   autoClose: 3000,
  //   hideProgressBar: true,
  //   closeOnClick: true,
  //   pauseOnHover: false,
  //   draggable: false,
  //   theme: "light",
  // };

  // const addAdressMutation = useMutation(addressAdd, {
  //   onSuccess: (res) => {
  //     toast.success("Dodano pomyślnie!", {
  //       toastId: "AddedSuccessfully",
  //       ...settings,
  //     });
  //     setAddressId(res.data.payload.id_klient);
  //   },
  // });

  const postalCodeRegExp = /^[0-9]{2}-[0-9]{3}/;

  const validationSchema = yup.object({
    kod_pocztowy: yup
      .string()
      .required("Kod pocztowy jest wymagany")
      .matches(postalCodeRegExp, "Błędny format!")
      .min(6, "Błędny format!")
      .max(6, "Błędny format!"),
    miejscowosc_poczty: yup
      .string(),
    miejscowosc: yup
      .string()
      .max(100, "Miejscowość nie może być dłuższa niż 100 znaków")
      .required("Miejscowość jest wymagana"),
    ulica: yup
      .string()
      .max(100, "Ulica nie może być dłuższa niż 100 znaków"),
    numer_budynku: yup
      .string()
      .max(5, "Numer budynku nie może być dłuższy niż 5 znaków")
      .required("Numer budynku jest wymagany"),
    numer_lokalu: yup
      .number()
      .typeError("Błędny format!")
      .max(99999, "Numer lokalu nie może być dłuższy niż 5 znaków"),
    wojewodztwo: yup
      .string()
      .required("Województwo jest wymagane"),
    kraj: yup
      .string()
      .required("Kraj jest wymagany"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      kod_pocztowy: addressData?.kod_pocztowy || "",
      miejscowosc_poczty: addressData?.miejscowosc_poczty || "",
      miejscowosc: addressData?.miejscowosc || "",
      ulica: addressData?.ulica || "",
      numer_budynku: addressData?.numer_budynku || "",
      numer_lokalu: addressData?.numer_lokalu || "",
      wojewodztwo: addressData?.wojewodztwo || "",
      kraj: "Polska",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // const body = {
      //   kod_pocztowy: values.kod_pocztowy,
      //   miejscowosc_poczty: values.miejscowosc,
      //   miejscowosc: values.miejscowosc,
      //   ulica: values.ulica === "" ? null : values.ulica,
      //   numer_budynku: values.numer_budynku,
      //   numer_lokalu: values.numer_lokalu === "" ? null : values.numer_lokalu,
      //   wojewodztwo: values.wojewodztwo,
      //   kraj: "Polska",
      // };
      // addAdressMutation.mutate(body);
    },
  });

  useEffect (() => {
    if (formik.isValid && formik.values.kod_pocztowy !== "" && formik.values.miejscowosc !== "" && formik.values.numer_budynku !== "" && formik.values.wojewodztwo !== "" && formik.values.kraj !== "") {
      setAddressDataValid(true);
      setAddressData(formik.values);
    } else if (!formik.isValid) {
      setAddressDataValid(false);
      setAddressData(formik.values);
    } else {
      setAddressDataValid(false);
    }
  }, [formik.values, formik.isValid])


  return (
    <>
    {/* <ButtonWrapper>
    <GoBackButton description={"Powrót"} goToUrl={-1} />
    </ButtonWrapper> */}
    <AdressAddFormWrapper>
    <BasicFormWrapper onSubmit={formik.handleSubmit}>
      <FormWrapper>
        <Input
          label="Kod pocztowy*"
          id="kod_pocztowy"
          name="kod_pocztowy"
          value={formik.values.kod_pocztowy}
          onChange={formik.handleChange}
          error={
            formik.touched.kod_pocztowy && Boolean(formik.errors.kod_pocztowy)
          }
          helperText={formik.touched.kod_pocztowy && formik.errors.kod_pocztowy}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Miejscowość*"
          id="miejscowosc"
          name="miejscowosc"
          value={formik.values.miejscowosc}
          onChange={formik.handleChange}
          error={
            formik.touched.miejscowosc && Boolean(formik.errors.miejscowosc)
          }
          helperText={formik.touched.miejscowosc && formik.errors.miejscowosc}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Ulica"
          id="ulica"
          name="ulica"
          value={formik.values.ulica}
          onChange={formik.handleChange}
          error={formik.touched.ulica && Boolean(formik.errors.ulica)}
          helperText={formik.touched.ulica && formik.errors.ulica}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Numer budynku*"
          id="numer_budynku"
          name="numer_budynku"
          value={formik.values.numer_budynku}
          onChange={formik.handleChange}
          error={
            formik.touched.numer_budynku && Boolean(formik.errors.numer_budynku)
          }
          helperText={
            formik.touched.numer_budynku && formik.errors.numer_budynku
          }
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Numer lokalu"
          id="numer_lokalu"
          name="numer_lokalu"
          value={formik.values.numer_lokalu}
          onChange={formik.handleChange}
          error={
            formik.touched.numer_lokalu && Boolean(formik.errors.numer_lokalu)
          }
          helperText={formik.touched.numer_lokalu && formik.errors.numer_lokalu}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <FormControl fullWidth>
          <InputLabel id="wojewodztwoLabel">Województwo*</InputLabel>
          <Select
            placeholder="Województwo"
            labelId="wojewodztwoLabel"
            id="wojewodztwo"
            name="wojewodztwo"
            value={formik.values.wojewodztwo}
            label="Województwo"
            onChange={formik.handleChange}
            // disabled={!isEditable}
            style={{ backgroundColor: "white" }}
          >
            {addressVoivodeshipsList.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Input
          disabled
          label="Kraj"
          id="kraj"
          name="kraj"
          value={formik.values.kraj}
          onChange={formik.handleChange}
          error={formik.touched.kraj && Boolean(formik.errors.kraj)}
          helperText={formik.touched.kraj && formik.errors.kraj}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        {/* <StyledButton
          disabled={
            !formik.isValid ||
            addAdressMutation.isLoading
          }
          type="submit"
          variant="contained"
        >
          Zapisz
        </StyledButton> */}
      </FormWrapper>
    </BasicFormWrapper>
    </AdressAddFormWrapper>
    </>
  );
};

export default AddressAddForm;

// const ButtonWrapper = styled.div`
//   width: 70%;
//   margin-left: 30px;
//   z-index: 10000;
//   // display: flex;
//   // justify-content: flex-start;


//   @media (${theme.device.laptop}) {
//     margin-left: 320px
//   }
// `;

const AdressAddFormWrapper = styled.div`
width: auto;
  display: flex;
  flex-direction: column;
  // margin-left: 320px;
  padding-right: 0;
  margin-top: 0px;
  @media (${theme.device.laptop}) {
    // width: 70%;
  }
`;

const BasicFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}) {
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 260px;
  max-width: 420px;
  gap: 25px;

  @media (${theme.device.laptop}) {
    width: 100%;
  }
`;
